import { ConfluenceSpaceAri } from '@atlassian/ari/confluence';
import { JiraProjectAri } from '@atlassian/ari/jira';
import { LoomSpaceAri } from '@atlassian/ari/loom';

import type { TeamContainerType } from '../../types';

export const getContainerType = (containerAri: string): TeamContainerType | undefined => {
	const isConfluenceSpace = ConfluenceSpaceAri.check(containerAri);
	const isJiraProject = JiraProjectAri.check(containerAri);
	const isLoomSpace = LoomSpaceAri.check(containerAri);

	if (isConfluenceSpace) {
		return 'Confluence';
	}

	if (isJiraProject) {
		return 'Jira';
	}

	if (isLoomSpace) {
		return 'Loom';
	}
};
